module.exports = __webpack_public_path__ + "static/media/teaching.bca37903.svg";